import type { WebinarRegia, WebinarRelatore } from '@aulaviva/shared';
import { useQuery } from '@tanstack/react-query';
import { richiesta } from './client';

export function useWebinarRelatore() {
  return useQuery({ queryKey: ['relatore', 'webinar'], queryFn: async () => (await richiesta<WebinarRelatore[]>('/relatore/webinar')).dati });
}

export function useWebinarRegia() {
  return useQuery({ queryKey: ['regia', 'webinar'], queryFn: async () => (await richiesta<WebinarRegia[]>('/regia/webinar')).dati });
}
